import { Checkbox, Field, RadioGroup, TextInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { SampleHistory, TimingMethod, WaterUsed } from '../../types';

let PreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const additionalVisualDescriptionRequired = useSelector(
    pipe(createWorksheetSelector!('AdditionalVisualDescriptionRequired'), valueOrDefault(true))
  );

  const timingMethod = useSelector(createWorksheetSelector!('TimingMethod')) as TimingMethod;

  const waterUsed = useSelector(createWorksheetSelector!('WaterUsed')) as WaterUsed;

  return (
    <>
      <ListFieldSection heading="Sample">
        <Field
          input={<RadioGroup />}
          name="SampleHistory"
          options={[
            { label: 'Natural state', value: SampleHistory.NaturalState },
            { label: 'Air-dried', value: SampleHistory.AirDried },
            { label: 'Oven-dried', value: SampleHistory.OvenDried },
            { label: 'Unknown', value: SampleHistory.Unknown },
          ]}
        />
        <FieldSet>
          <Field input={<Checkbox />} name="AdditionalVisualDescriptionRequired" />
          <Field input={<TextInput />} name="VisualDescription" visible={additionalVisualDescriptionRequired} />
        </FieldSet>
      </ListFieldSection>
      <ListFieldSection heading="Equipment">
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="LargeSieve"
          queryParams={{ SieveSize: '0.00475 m' }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="SmallSieve"
          queryParams={{ SieveSize: '0.00236 m' }}
        />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="thermometer" name="Thermometer" />
        <WorksheetBalanceFieldSet name="Balance" />
        <Field
          input={<RadioGroup />}
          name="TimingMethod"
          options={[
            { label: 'Clock or watch', value: TimingMethod.ClockOrWatch },
            { label: 'Calibrated timer', value: TimingMethod.CalibratedTimer },
          ]}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="timer"
          name="Timer"
          visible={timingMethod === TimingMethod.CalibratedTimer}
        />
      </ListFieldSection>
      <ListFieldSection heading="Water Source">
        <FieldSet>
          <Field
            input={<RadioGroup />}
            name="WaterUsed"
            options={[
              { label: 'Distilled water', value: WaterUsed.DistilledWater },
              { label: 'Other', value: WaterUsed.Other },
            ]}
          />
          <Field input={<TextInput />} name="WaterDescription" visible={waterUsed === WaterUsed.Other} />
        </FieldSet>
      </ListFieldSection>
    </>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
